import { Loaders } from './models';

const loaders: Loaders = {
    rest: []
}

export default loaders